<script>
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  
  export let header = '';

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

  let modal;

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
  }
  
  onMount(async () => {
    // Set modal height if it's taller than the viewport.
    const wh = window.innerHeight;
    const mh = modal.offsetHeight;
    if ((mh + 100) > wh) {
      modal.style.height = (wh - 100) + 'px';
    }
  });
</script>

<style>
	.modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.6);
	}

	.modal {
		position: fixed;
		left: 50%;
		top: 50%;
		width: calc(100vw - 4em);
		max-width: 50em;
		overflow: auto;
		transform: translate(-50%,-50%);
		padding: 1em;
		border-radius: 0.2em;
		background: white;
	}

  .modal-content {
    max-width: 100%;
    overflow: hidden;
  }

	.close-button {
    height: 30px;
    width: 30px;
    text-align: center;
		display: block;
    background: none;
    border: none;
    position: absolute;
    right: .5em;
    top: .5em;
  }
  .close-button svg {
    height: 13px;
    width: 13px;
  }

  .modal :global(h2) {
    margin-top: 0;
  }

  @media (min-width: 1024px) {   
    .modal-content {
      padding: 1em 2em;
    }
  }
</style>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}></div>

<div class="modal" role="dialog" aria-modal="true" bind:this={modal}>
  <!-- svelte-ignore a11y-autofocus -->
	<button class="close-button" title="Close" autofocus on:click={close}>
    <span class="visually-hidden">Close Modal</span>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13"><defs/><path fill="currentColor" fill-rule="nonzero" d="M11.96.646a1 1 0 01.078 1.327l-.078.088-4.242 4.242 4.242 4.243a1 1 0 01-1.327 1.492l-.087-.078-4.243-4.242L2.06 11.96a1 1 0 01-1.492-1.327l.077-.087L4.89 6.303.646 2.06A1 1 0 011.973.569l.088.077L6.303 4.89 10.546.646a1 1 0 011.414 0z"/></svg>
  </button>
  <div class="modal-content">
    {#if header}
    <h2>{header}</h2>
    {/if}
    <slot></slot>
  </div>
</div>
